// @ts-nocheck
import PropTypes from "prop-types";
import { useDrag } from "react-dnd";
import { v4 as uuid } from "uuid";
import styles from "../contractDetails.module.css";
import { getCssVariableHandler } from "../../../utils/styles/getCssVariables";
import { useEffect, useLayoutEffect, useState } from "react";
import LineClamp from "../../positions/components/LineClamp";
import { Button } from "@mui/material";
import { CustomIconButton } from "../../../components/Custom/CustomIconButton";
import { Check, Close, Delete } from "@mui/icons-material";
import SignatureModal from "./SignatureModal";
import { useDispatch } from "react-redux";
import {
  addSignatureAction,
  deleteSignatureAction,
  editSignatureAction,
} from "../../../store/actions/contract/contract";
import { debounce } from "lodash";

export default function DraggableTool({
  item,
  setFields,
  currPage,
  idx,
  setFieldsOnPdf,
}) {
  const [isEdit, setIsEdit] = useState(false);
  const [openSignatureModal, setOpenSignatureModal] = useState(false);
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: "TOOL",
      item: { item },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [item],
  );
  const dispatch = useDispatch();

  const handleTouch = () => {
    const pdfArea = document.querySelector("#drop-area");
    if (!pdfArea) return;

    const rect = pdfArea.getBoundingClientRect();
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    setFieldsOnPdf((prev) => [
      ...prev,
      {
        id: uuid(),
        _id: item?._id,
        type: item?.type,
        value: item?.text || item?.url,
        x: centerX,
        y: centerY,
        page: currPage,
        width: 120,
        height: 40,
      },
    ]);
  };

  function newButtonClick() {
    setFields((prev) =>
      prev?.map((item) => {
        if (item?.type === "Signature") return item;
        else
          return {
            ...item,
            list: [
              ...item.list.slice(0, -1),
              { type: "Text", text: "Custom Text", isNew: true },
              item.list[item.list.length - 1],
            ],
          };
      }),
    );
  }

  function deleteClickHandler(type, deleteIdx) {
    setFields((prev) =>
      prev.map((item) => {
        if (item?.type !== type) return item;

        return {
          ...item,
          list: item.list.filter((_, idx) => idx !== deleteIdx),
        };
      }),
    );
  }

  function renderOptions() {
    switch (item?.type) {
      case "Text":
        if (item?.button === "New") {
          return (
            <Button
              sx={{
                padding: "0.25rem 0.5rem",
                width: "100%",
                backgroundColor: "black",
                border: "1px solid",
                borderColor: getCssVariableHandler({
                  variableName: "--primary-pink-rgb",
                }),
              }}
              onClick={newButtonClick}
            >
              Create New
            </Button>
          );
        } else {
          return <LineClamp text={item?.text} maxLines={1} />;
        }
      case "Signature":
        if (item?.button === "New") {
          return (
            <>
              <Button
                sx={{
                  padding: "0.25rem 0.5rem",
                  width: "100%",
                  backgroundColor: "black",
                  border: "1px solid",
                  borderColor: getCssVariableHandler({
                    variableName: "--primary-pink-rgb",
                  }),
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  setOpenSignatureModal(true);
                }}
              >
                Create New Signature
              </Button>
              {/* NOTE: pass debounce function and add file as signature */}
              <SignatureModal
                open={openSignatureModal}
                onClose={() => setOpenSignatureModal(false)}
                setFields={setFields}
                addSignature={debouncedHandleAddAndEditSignature}
              />
            </>
          );
        } else {
          return (
            <img
              height={"50px"}
              width={"80%"}
              src={item?.text}
              alt="signature text"
            />
          );
        }

      default:
        return null;
    }
  }

  // NOTE: api's handeling
  const debouncedHandleAddAndEditSignature = debounce(
    async (data, dispatch) => {
      let formData = new FormData();
      if (data?.type === "Text") {
        formData.append("text", data?.text);
      } else {
        const res = await fetch(data?.text);
        const blob = await res.blob();
        formData.append("files", blob, `${data?.id}-sign.png`);
        formData.append("usersConsent", true);
      }

      if (data?._id) {
        // edit signature
        dispatch(
          editSignatureAction({
            payload: {
              data: formData,
              params: {
                ...(data?.type == "Text"
                  ? {
                      textId: data?._id,
                    }
                  : {
                      fileId: data?._id,
                    }),
              },
            },
          }),
        );
      } else {
        // add signature
        dispatch(
          addSignatureAction({
            payload: { data: formData },
          }),
        );
      }
    },
    500,
  );

  const deleteSignatureHandler = (data) => {
    if (!data?._id) return;
    let params = {};
    if (data?.type == "Text") {
      params.textId = data?._id;
    } else {
      params.fileId = data?._id;
    }

    dispatch(
      deleteSignatureAction({
        payload: {
          params,
        },
      }),
    );
  };

  useLayoutEffect(() => {
    if (item?.isNew) {
      setIsEdit(true);
    }
  }, [item]);

  return (
    <div
      ref={drag}
      className={styles["tool-item"]}
      onTouchStart={(e) => {
        handleTouch(e);
        const el = e.currentTarget;
        el.classList.add(styles["touch-effect"]);
        setTimeout(() => {
          el.classList.remove(styles["touch-effect"]);
        }, 150);
      }}
      // onDoubleClick={() => {
      //   if (item?.button) return;
      //   if (item?.type === "Text") {
      //     setIsEdit(true);
      //   }
      // }}
      style={{
        cursor: isDragging ? "grabbing" : "grab",
        backgroundColor: getCssVariableHandler({
          variableName: "--primary-pink-rgb-light",
        }),
        ...(item?.button == "New" ? { padding: "0px" } : {}),
      }}
    >
      {isEdit ? (
        <textarea
          autoFocus
          onFocus={(e) => e?.target?.select()}
          style={{
            width: "100%",
            height: "100%",
            resize: "none",
            border: "none",
            outline: "none",
            background: "transparent",
            color: "white",
            font: "inherit",
          }}
          value={item?.text ?? ""}
          onChange={(e) => {
            const value = e.target.value;
            setFields((prev) =>
              prev.map((group) => {
                if (group.type === "Text") {
                  return {
                    ...group,
                    list: group?.list?.map((tool, i) => {
                      if (i === idx) {
                        return { ...tool, text: value };
                      } else {
                        return tool;
                      }
                    }),
                  };
                }
                return group;
              }),
            );
          }}
          onBlur={(e) => {
            setIsEdit(false);
            const value = e?.target?.value;
            const currentItem = item?.list?.[idx] || item;
            debouncedHandleAddAndEditSignature(
              { ...currentItem, text: value },
              dispatch,
            );
          }}
        />
      ) : (
        renderOptions()
      )}
      {item?.button !== "New" ? (
        isEdit ? (
          <CustomIconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsEdit(false);
              const currentItem = item?.list?.[idx] || item;
              debouncedHandleAddAndEditSignature(
                { ...currentItem, text: item?.text },
                dispatch,
              );
            }}
            sx={{
              borderRadius: "50%",
              backgroundColor: getCssVariableHandler({
                variableName: "--white-rgb",
              }),
              padding: "0.15rem",
              "&:hover": {
                opacity: "0.8",
                backgroundColor: getCssVariableHandler({
                  variableName: "--white-rgb",
                }),
              },
            }}
          >
            <Check sx={{ fontSize: "1rem", color: "black" }} />
          </CustomIconButton>
        ) : (
          <CustomIconButton
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setOpenSignatureModal(false);
              deleteClickHandler(item?.type, idx);
              deleteSignatureHandler(item);
            }}
            sx={{
              borderRadius: "50%",
              backgroundColor: getCssVariableHandler({
                variableName: "--white-rgb",
              }),
              padding: "0.15rem",
              "&:hover": {
                opacity: "0.8",
                backgroundColor: getCssVariableHandler({
                  variableName: "--white-rgb",
                }),
              },
            }}
          >
            <Close sx={{ fontSize: "1rem", color: "black" }} />
          </CustomIconButton>
        )
      ) : null}
    </div>
  );
}
DraggableTool.propTypes = {
  type: PropTypes.string,
  setFields: PropTypes.func,
  currPage: PropTypes.number,
  item: PropTypes.object,
  idx: PropTypes.number,
  setFieldsOnPdf: PropTypes.func,
};